
import { useForm } from "react-hook-form"
import type { User } from "firebase/auth"
import { api } from "../../core"
import type { LiveId, SelectionId, SelectionSequenceId, SpaceKey } from "popopo-msg"
import { useToast } from "popopo-lib-front/hook"

export const SelectionSequenceParticipantForm = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId; selectionId: SelectionId, sequence: SelectionSequenceId | null }) => {
  const form = useForm({
    mode: "onBlur",
  })
  const { spaceKey, liveId, selectionId } = props
  const toast = useToast()
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (open: boolean) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.POST("/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/sequences/participate", {
        params: {
          path: {
            space_key: spaceKey,
            live_id: liveId,
            selection_id: selectionId,
          },
        },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          open,
          sequence: {
            id: props.sequence ?? ""
          }
        }
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "Close", message: JSON.stringify(res.data) })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "Close", message: e.toString() })
    }
  }

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(() => onSubmit(true))}>
        <button type="submit" className="btn btn-warning form-control" disabled={isSubmitting || !isValid}>
          Open
        </button>
      </form>

      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(() => onSubmit(false))}>
        <button type="submit" className="btn btn-warning form-control" disabled={isSubmitting || !isValid}>
          Close
        </button>
      </form>
    </>
  )
}
